/**
 * Тратимые монеты (ISSUE-149): покупку сервер считает по своему кошельку, а клиент прибавляет монеты волны сразу после
 * итога, до ответа на журнал. Кнопки покупок смотрят только на {@link spendableCoins}; монеты в пути показываются
 * отдельно. После отказа «не хватает монет» кнопки гаснут до следующего зачисления ({@link coinsShortActive}).
 */
import { appStore, patch, type AppState } from "./app-state";

/** Монеты, которые сервер уже зачислил: кошелёк игрока без монет волн, чей журнал ещё не принят. */
export function spendableCoins(s: AppState): number {
  return Math.max(0, (s.player?.coins ?? 0) - s.coinsInFlight);
}

/** Кнопки покупок погашены: сервер отказал, и с тех пор тратимых монет не прибавилось. */
export function coinsShortActive(s: AppState): boolean {
  return s.coinsShort !== null && spendableCoins(s) <= s.coinsShort;
}

/** Отказ гаснет, как только тратимых монет стало больше, чем было у сервера при отказе. */
const released = (s: AppState): Partial<AppState> =>
  s.coinsShort !== null && !coinsShortActive(s) ? { coinsShort: null } : {};

/** Итог волны прибавил монеты к игроку, журнал ещё не принят. */
export function addCoinsInFlight(coins: number, store = appStore): void {
  if (coins > 0) patch((s) => ({ coinsInFlight: s.coinsInFlight + coins }), store);
}

/** Журналов в очереди не осталось: состояние игрока — сервера, все его монеты тратимые. */
export function clearCoinsInFlight(store = appStore): void {
  patch((s) => {
    const next = { ...s, coinsInFlight: 0 };
    return { coinsInFlight: 0, ...released(next) };
  }, store);
}

/** Сервер ответил «не хватает монет»; `serverCoins` — его кошелёк в этот момент. */
export function markCoinsShort(serverCoins: number, store = appStore): void {
  patch(() => ({ coinsShort: serverCoins }), store);
}

/** Сверить отказ после смены игрока: зачисление снимает его. */
export function releaseCoinsShort(s: AppState): Partial<AppState> {
  return released(s);
}
